/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { UnsavedChangesState } from "~/features/unsavedChanges/types";
import { RootState } from "~/state/types";

const getState = (state: RootState) => state.unsavedChanges;

const createSelector =
  <TSelected = unknown>(selector: (state: UnsavedChangesState) => TSelected): ((rootState: RootState) => TSelected) =>
  (rootState) =>
    selector(getState(rootState));

export const selectUnsavedChangesData = createSelector((state) => state);
